import { all, fork } from 'redux-saga/effects';
import field from './fieldSaga';
import bulkEdit from './entitySagas/bulkEditSaga';
import accounts from './entitySagas/accountSaga';
import moveLinkedEntity from './entitySagas/moveEntitySaga';
import organizations from './entitySagas/organizationSaga';
import contacts from './entitySagas/contactSaga';
import pipelines from './entitySagas/pipelineSaga';
import tableColumns from './tableColumnSaga';
import segments from './segmentSaga';
import fieldMapping from './fieldMappingSaga';
import emailAuth from './emailAuthSaga';
import fieldPin from './fieldPinSaga';
import entityAction from './entitySagas/entityActionSaga';
import partialDataList from './entitySagas/partialDataListSaga';
import entityActivity from './entitySagas/entityActivitySaga';
import entityChangeLog from './entitySagas/entityChangeLogSaga';
import myEntityChangeMgmt from './entitySagas/myEntityChangeMgmt';
import auth from './authSaga';
import userManagement from './userManagementSaga';
import userEmailSignature from './emailSignatureSaga';
import currentUserSaga from './currentUserSaga';
import currency from './currencySaga';
import lifecycles from './lifecyclesSaga';
import summaryCollapseStatus from './summaryCollapseStatusSaga';
import health from './healthSaga';
import imageUpload from './imageUploadSaga';
import fileUpload from './fileUploadSaga';
import zendesk from './integrationSagas/zendeskSaga';
import gmail from './integrationSagas/gmailSaga';
import slack from './slackSaga';
import emailTemplate from './emailTemplateSaga';
import notifications from './notificationSaga';
import statBar from './statBarSaga';
import reporting from './reportingSaga';
import integrationData from './integrationSagas/integrationDataSaga';
import integrationSaga from './integrationSagas/integrationSaga';
import crmIntegrationSaga from './integrationSagas/crmIntegrationSaga';
import emailSaga from './emailSaga';
import tasks from './taskAndPlaybookSagas/taskSaga';
import taskBoardViewSaga from './taskAndPlaybookSagas/taskBoardViewSaga';
import playbookTemplates from './taskAndPlaybookSagas/playbookTemplateSaga';
import tickets from './ticketSaga';
import playbookInstances from './taskAndPlaybookSagas/playbookInstanceSaga';
import entityDataExport from './dataExportSaga';
import scenarios from './scenarioSagas/scenarioSaga';
import notificationConfiguration from './notificationConfigurationSaga';
import webhooks from './webhookSaga';
import surveys from './surveySaga';
import activityTypes from './activityTypeSaga';
import googleCalendar from './integrationSagas/googleCalendarSaga';
import healthBreakdown from './healthBreakdownSaga';
import successPlanSaga from './successPlanSaga';
import successPlanSagaV2 from './successPlanSagaV2';
import successPlanMilestoneSaga from './successPlanMilestoneSaga';
import successPlanMilestoneSagaV2 from './successPlanMilestoneSagaV2';
import successPlanKPISaga from './successPlanKPISaga';
import successPlanKPISagaV2 from './successPlanKPISagaV2';
import allSuccessPlansSaga from './allSuccessPlansSaga';
import supportIntegration from './integrationSagas/supportIntegrationSaga';
import cockpitSaga from './cockpitSaga';
import calendarSaga from './calendarSaga';
import filteredViewsSaga from './filteredViewsSaga';
import conversation from './conversationSaga';
import unsubscription from './unsubscriptionSaga';
import initialization from './initializationSaga';
import workSpaceSaga from './workSpaceSaga';
import vice from './viceSaga';
import outlookCalendar from './integrationSagas/outlookCalendarSaga';
import emailCampaign from './emailCampaignSaga';
import velarisAi from './velarisAiSagas';
import communicationIntegrationSaga from './integrationSagas/communicationIntegrationSaga';
import teams from './teamsSaga';
import eventConfigSaga from './integrationSagas/eventConfigSaga';
import globalConfigSaga from './globalConfigSaga';
import successPlanTemplateKpiSaga from './successPlanTemplates/successPlanTemplatesKpiSaga';
import customObjectSaga from './customObjectSaga';
import successPlanTemplateMilestoneSaga from './successPlanTemplates/successPlanTemplatesMilestoneSaga';
import globalSearchSaga from './globalSearchSaga';
import connectConfigurationSaga from './connectConfigurationSaga';
import velarisSupport from './velarisSupportSaga';
import entityPartialListSagaV2 from './entitySagas/entityPartialListSagaV2';
import linkedEntitySaga from './entitySagas/linkedEntitySaga';
import successPlanTemplateSaga from './successPlanTemplates/successPlanTemplatesSaga';

export default function* root() {
  yield all([
    fork(bulkEdit),
    fork(accounts),
    fork(organizations),
    fork(contacts),
    fork(pipelines),
    fork(field),
    fork(tableColumns),
    fork(segments),
    fork(fieldMapping),
    fork(emailAuth),
    fork(fieldPin),
    fork(entityAction),
    fork(entityActivity),
    fork(imageUpload),
    fork(fileUpload),
    fork(auth),
    fork(userManagement),
    fork(userEmailSignature),
    fork(currentUserSaga),
    fork(currency),
    fork(lifecycles),
    fork(summaryCollapseStatus),
    fork(health),
    fork(slack),
    fork(emailTemplate),
    fork(unsubscription),
    fork(healthBreakdown),
    fork(moveLinkedEntity),
    fork(zendesk),
    fork(gmail),
    fork(notifications),
    fork(statBar),
    fork(reporting),
    fork(integrationData),
    fork(emailSaga),
    fork(tasks),
    fork(taskBoardViewSaga),
    fork(playbookTemplates),
    fork(tickets),
    fork(playbookInstances),
    fork(entityDataExport),
    fork(partialDataList),
    fork(integrationSaga),
    fork(scenarios),
    fork(entityChangeLog),
    fork(myEntityChangeMgmt),
    fork(crmIntegrationSaga),
    fork(notificationConfiguration),
    fork(webhooks),
    fork(surveys),
    fork(activityTypes),
    fork(successPlanSaga),
    fork(successPlanSagaV2),
    fork(successPlanMilestoneSaga),
    fork(successPlanMilestoneSagaV2),
    fork(allSuccessPlansSaga),
    fork(googleCalendar),
    fork(successPlanKPISaga),
    fork(successPlanKPISagaV2),
    fork(supportIntegration),
    fork(cockpitSaga),
    fork(calendarSaga),
    fork(filteredViewsSaga),
    fork(conversation),
    fork(workSpaceSaga),
    fork(initialization),
    fork(vice),
    fork(outlookCalendar),
    fork(emailCampaign),
    fork(velarisAi),
    fork(communicationIntegrationSaga),
    fork(teams),
    fork(eventConfigSaga),
    fork(globalConfigSaga),
    fork(successPlanTemplateKpiSaga),
    fork(customObjectSaga),
    fork(successPlanTemplateMilestoneSaga),
    fork(globalSearchSaga),
    fork(connectConfigurationSaga),
    fork(velarisSupport),
    fork(entityPartialListSagaV2),
    fork(linkedEntitySaga),
    fork(successPlanTemplateSaga),
  ]);
}
